export default __webpack_public_path__ + "static/media/banner10.a9cb9375.jpeg";